export const read = async (skip, query, searchThis) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/listSurat?skip=${skip}&query=${query || ""}&searchThis=${searchThis || "Perusahaan"}`;

    console.log("READ SURAT URL:", url);

    const res = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    console.log("READ SURAT STATUS:", res.status);

    const result = await res.json();

    console.log("READ SURAT RESULT:", result);

    return result;
  } catch (error) {
    console.log("READ SURAT FETCH ERROR:", error);

    return {
      success: false,
      data: [],
      error: error?.message || "Load failed",
    };
  }
};